
const digest = 'a1967c889defab3d4e6ced2b942137c70eb92007739b320ca82470ec84ade3b2';
const classes = {"eventCard":"_eventCard_73j2h_1","selected":"_selected_73j2h_13","detailsPanel":"_detailsPanel_73j2h_18","detailRow":"_detailRow_73j2h_28","label":"_label_73j2h_33"};
const css = `._eventCard_73j2h_1 {
  text-align: left;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 0;
  background: none;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}
._eventCard_73j2h_1:hover {
  background-color: var(--color-bg-secondary, #f5f5f5);
}
._eventCard_73j2h_1._selected_73j2h_13 {
  border-color: var(--color-primary, #1976d2);
  background-color: var(--color-bg-secondary, #f5f5f5);
}

._detailsPanel_73j2h_18 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background-color: var(--color-bg-secondary, #f5f5f5);
  border-radius: 8px;
  font-family: Rubik, sans-serif;
}

._detailRow_73j2h_28 {
  display: flex;
  gap: 8px;
}

._label_73j2h_33 {
  font-weight: 600;
  min-width: 120px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  